import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function HeroSection() {
  const { t } = useTranslation('HeroSection');

  return (
    <section className="bg-white dark:bg-gray-950 mt-24 py-20">
      <div className="container mx-auto flex flex-col lg:flex-row items-center px-6 lg:px-20">
        {/* Texte de la bannière */}
        <div className="lg:w-1/2 text-center lg:text-left mb-10 mr-6 lg:mb-0">
          <h1 className="text-5xl font-bold text-gray-800 mb-4 dark:text-gray-50">
            {t('title')} {t('tiret')} <span className="text-blue-600">{t('title1')}</span><br />
            {t('title2')}
          </h1>
          <p className="text-gray-600 dark:text-gray-400 text-lg mb-6">
            {t('description')}
          </p>
          <Link to="/contact">
            <button className="bg-blue-600 text-white py-2 px-6 rounded-full font-medium hover:bg-blue-700">
              Contact Us
            </button>
          </Link>
        </div>

        {/* Illustration de la bannière */}
        <div className="lg:w-1/2">
          <img 
            src="/images/lizayTech.jpg" 
            alt="IT Solutions" 
            width={500}
            height={400}
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
